const items = [
  "Keep the Commandments",
  "Honor the Sabbath",
  "The Dietary Law",
  "The Holy Feast Days",
  "Obey His Law",
  "Restore the Truth",
];

export const Marquee = () => {
  const loop = [...items, ...items];
  return (
    <div data-testid="marquee-strip" className="bg-[#D4AF37] text-[#0A0A0A] py-4 overflow-hidden border-y border-[#0A0A0A]">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {loop.map((t, i) => (
          <span key={i} className="flex items-center font-heading text-2xl italic px-8">
            {t}
            <span className="ml-8 not-italic">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
